import { IAlertConfig } from '../../types/Alert/IAlertConfig';
import { Api } from './BaseApi'

const AlertApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getAlertConfig: build.query<IAlertConfig, void>({
            query: () => ({
                url: "Alert/Config",
                method: "GET"
            }),
            providesTags: ["GetAlertConfig"]
        }),
    }),
    overrideExisting: false,
})

export { AlertApi };